import { FC } from "react";
import { AllieChipProps } from "./Chip.types";
import { StyledChip } from "./Chip.styles";

export const AllieChip: FC<AllieChipProps> = ({
  allieType = 'primary',
  outline = false,
  disabled = false,
  ...props
}) => <StyledChip color={allieType} outline={outline} disabled={disabled} {...props} />;
